import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import OperationCard from 'components/cards/OperationCard';
import BackOfficeIPCameraAddDrawer from 'components/drawers/BackOfficeIPCameraAddDrawer';
import FarmbotSecurityCameraIcon from 'components/icons/FarmbotSecurityCameraIcon';
import IntegrationIcon from 'components/icons/IntegrationIcon';
import { ErrorBoundary } from 'config/sentry';
import { SEARCH_PARAMS } from 'constants/search-params';
import { useMyUserHasInternalPermission } from 'store/modules/myUser/hooks';
import { ProtectedResource, ResourceAction } from 'types/action.enum';
import { useReadyFlag } from 'utils/useReadyFlags';

import './styles.less';

function BackOfficeOperations() {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const enableSelfServeDataTransfer = useReadyFlag('enableSelfServeDataTransfer');

  const canProvisionIPCameras = useMyUserHasInternalPermission({
    resource: ProtectedResource.IP_CAMERA,
    action: ResourceAction.ADD
  });

  const openIPCameraAddDrawer = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.set(SEARCH_PARAMS.DRAWER.key, SEARCH_PARAMS.DRAWER.values.ADD_IP_CAMERA);
      return newSearchParams;
    });
  };

  const operations = [
    ...enableSelfServeDataTransfer ? [{
      title: 'Data transfer',
      onClick: () => {
        navigate('/back-office/operations/data-transfer');
      },
      Icon: IntegrationIcon,
      caption: 'Transfer sample data from an old sensor to a new one'
    }] : [],
    ...canProvisionIPCameras ? [
      {
        title: 'Add IP Camera',
        onClick: openIPCameraAddDrawer,
        caption: 'For Farmbot Security Cameras manufactured by Land Watch',
        Icon: FarmbotSecurityCameraIcon
      }
    ] : []
  ];

  return (
    <ErrorBoundary>
      <PageHeaderPusher>
        <>
          <BackOfficeIPCameraAddDrawer />
          {!operations.length ? (
            <div className="BackOfficeOperations-empty-state">
              No allowed operations
            </div>
          ) : (
            <div className="BackOfficeOperations-operations-list">
              {operations.map((operation, index) => (
                <OperationCard
                  key={index}
                  title={operation.title}
                  caption={operation.caption}
                  Icon={operation.Icon}
                  onClick={operation.onClick}
                />
              ))}
            </div>
          )}
        </>
      </PageHeaderPusher>
    </ErrorBoundary>
  );
}

export default BackOfficeOperations;
